import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter, useHistory } from 'react-router-dom'
import { routes } from '../../constantes/routes'
import { hospitalsContactsActions } from '../../actions/hospitalsContactsActions'
import { timeSlotsActions } from '../../actions/timeSlotsActions'
import PlusBtn from '../buttons/PlusBtn'
import Search from '../common/Search'
import {
  swalAlertIsConfirm,
  swalAlertError,
  swalSuccessGeneral,
} from '../../utils/swalAlert'
import { swalTitle } from '../../constantes/swalTitle'
import ContactsHospitalsList from './ContactsHospitalsList'
import Header from '../header/Header'
import _ from 'lodash'
import { contactsActions } from '../../actions/contactsActions'
import { hospitalsContactsTypes } from '../../constantes/actionTypes'
import { mssgs } from '../../constantes/mssgs'
import NewContactNoteModal from './contactHospitals/NewContactNoteModal'
import { downloadCSV } from '../../utils/downloadCSV'
import { exportActions } from '../../actions/exportActions'
import { entitiesExport } from '../../constantes/exportEndpoints'
import { hospitalsActions } from '../../actions/hospitalsActions'

const ContactsHospitalsContainer = () => {
  const history = useHistory()

  const hospitalsContacts = useSelector((state) => state.hospitalsContacts)
  const userProfile = useSelector((state) => state.userProfile)
  const zones = useSelector((state) => state.zones)
  const communities = useSelector((state) => state.communities)

  const [items, setItems] = useState(hospitalsContacts)
  const [page, setPage] = useState(1)
  const [comunidad, setComunidad] = useState(0)
  const [search, setSearch] = useState('none')
  const [firstRender, setFirstRender] = useState(true)

  const dispatch = useDispatch()
  // console.log('idTipoZona', comunidad)
  const getAllTimeSlots = () => dispatch(timeSlotsActions.getAllTimeSlots())
  const getAllHospitalContactsFilteredPaged = (page, comunidad, search) =>
    dispatch(
      hospitalsContactsActions.getAllContactsHospitalsByZoneNamePaged(
        page,
        comunidad,
        search,
      ),
    )
  const deleteHospitalContacts = (idContact) =>
    dispatch(hospitalsContactsActions.deleteContactHospitals(idContact))
  const clearAllHospitalContacts = () =>
    dispatch(hospitalsContactsActions.clearAllContactHospitals())
  const deleteContact = (idContact) =>
    dispatch(contactsActions.deleteContact(idContact))
  const getAllComunities = () => dispatch(hospitalsActions.getAllCommunities())

  useEffect(() => {
    getAllTimeSlots()
    getAllComunities()
    resetList()
    window.addEventListener('scroll', _.throttle(handleScroll, 500))
  }, [])

  useEffect(() => {
    setItems(hospitalsContacts)
  }, [hospitalsContacts])

  useEffect(() => {
    if (page > 1) getAllHospitalContactsFilteredPaged(page, comunidad, search)
  }, [page])

  useEffect(() => {
    if (!firstRender) resetList()
    else setFirstRender(false)
  }, [comunidad, search])

  const resetList = () => {
    clearAllHospitalContacts()
    setPage(1)
    getAllHospitalContactsFilteredPaged(page, comunidad, search)
  }

  const handleRemove = async (idContact) => {
    try {
      const alert = await swalAlertIsConfirm(
        '¿Seguro que quieres eliminar el contacto? Eliminaras todos los hospitales asociados a este contacto',
      )
      if (alert.isConfirmed) {
        deleteContact(idContact)
        const response = await deleteHospitalContacts(idContact)
        if (
          response.type ===
          hospitalsContactsTypes.DELETE_HOSPITALS_CONTACT_SUCCES
        ) {
          swalSuccessGeneral(
            swalTitle.Eliminado,
            mssgs.DELETE_RECORD_SUCCESSFULLY,
          )
        }
      }
    } catch (error) {
      swalAlertError(error.payload)
    }
  }

  const handleScroll = () => {
    const documentHeight = document.body.scrollHeight
    const currentScroll = window.scrollY + window.innerHeight
    const modifier = 50

    if (currentScroll + modifier > documentHeight) {
      setPage((p) => p + 1)
    }
  }

  const handleChangeOption = (event) => {
    // console.log('event.target.value', event.target.value)
    const value = event.target.value
    setComunidad(value)
  }

  const onChangeSearch = (value) => {
    const searchValue = value.trim() === '' ? 'none' : value.trim()
    setSearch(searchValue)
  }

  const toNewContact = () => {
    history.push(routes.CONTACT_NEW)
  }

  const toEditContact = (id) => {
    history.push(routes.CONTACT_EDIT + id)
  }

  const toViewContact = async (id) => {
    history.push(routes.CONTACT_DETAIL + id)
  }

  const toMain = () => {
    history.push(routes.MAIN)
  }

  const zonasFiltradas = _.orderBy(zones, ['nombre'], ['asc'])

  const handleExportCSV = async () => {
    const response = await dispatch(
      exportActions.exportCSV(entitiesExport.CONTACTS),
    )
    downloadCSV('Contactos', response)
  }

  return (
    <>
      {
        <div className='products'>
          <Header text={'Contactos'} route={toMain} backBtn={true} />
          <div className='filter__wrap mb-80'>
            {userProfile.roles.isContactosVerTodos ? (
              <div className='sort-role__wrap'>
                <h4 className='filter__title'>Filtrar por</h4>
                <select className='select-filter' onChange={handleChangeOption}>
                  <option value={0} className='options-field'>
                    Todas las comunidades
                  </option>
                  {communities.length > 0
                    ? communities.map((zona) => (
                        <option
                          key={zona}
                          value={zona}
                          className='options-field'
                        >
                          {String(zona)}
                        </option>
                      ))
                    : null}
                </select>
              </div>
            ) : null}
            <Search
              onChangeSearch={onChangeSearch}
              placeholder={'Buscar por nombre del contacto...'}
            />
            <div className='add__action__rigth__side'>
              <button
                onClick={handleExportCSV}
                className='btn-landing'
                style={{ cursor: 'pointer', marginLeft: '10px' }}
              >
                📊 Exportar CSV
              </button>
              <button className='action-button' onClick={toNewContact}>
                <PlusBtn />
                <span>Nuevo contacto</span>
              </button>
            </div>
          </div>
          <ContactsHospitalsList
            hospitalsContacts={items}
            handleRemove={handleRemove}
            toViewContact={toViewContact}
            toEditContact={toEditContact}
            userProfile={userProfile}
            zones={zones}
          />
        </div>
      }
    </>
  )
}

export default withRouter(ContactsHospitalsContainer)
